
<template>
  <div>
    <div id="surveyCreatorContainer"></div>

    <!-- Edit Modal -->
    <modal :show.sync="modals.classic" headerClasses="justify-content-center">
      <h4 slot="header" class="title title-up">{{ $t('update_page_information') }}</h4>
      <ValidationObserver ref="formBuilderForm">
        <form>
          <ValidationProvider
            name="name"
            rules="required|min:3"
            v-slot="{ errors }"
          >
            <fg-input
              :error="errors[0]"
              v-model="formData.title"
              :placeholder="$t('title')"
              :label="$t('title')"
            ></fg-input>
          </ValidationProvider>
          <fg-input :label="$t('select_content_type')">
            <el-select
              size="large"
              class="select-primary"
              filterable
              clearable
              v-model="formData.contentType_ID"
              :placeholder="$t('select_content_type')"
            >
              <el-option
                v-for="item in contentTypes"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </fg-input>
        </form>
      </ValidationObserver>
      <template slot="footer">
        <div class="left-side">
          <p-button type="danger" link @click="handleCloseModal"
            >{{ $t('cancel') }}</p-button
          >
        </div>
        <div class="divider"></div>
        <div class="right-side">
          <p-button type="info" link @click="updateForm">{{ $t('update_form') }}</p-button>
        </div>
      </template>
    </modal>
  </div>
</template>

<script>
import * as SurveyCreator from "survey-creator";
import "survey-creator/survey-creator.css";
import * as SurveyKo from "survey-knockout";
import * as widgets from "surveyjs-widgets";
import Modal from "src/components/UIComponents/Modal.vue";

widgets.icheck(SurveyKo);
widgets.select2(SurveyKo);
widgets.inputmask(SurveyKo);
widgets.jquerybarrating(SurveyKo);
widgets.select2tagbox(SurveyKo);
widgets.signaturepad(SurveyKo);
widgets.ckeditor(SurveyKo);


import Resource from "@/util/Api/resource.js";
const PageResource = new Resource("postTemplate");
const UpdatePageResource = new Resource("postTemplate/update");
const CategoryResource = new Resource("category");
export default {
  name: "edit-page-template",
  components: {
    Modal
  },
  data() {
    return {
      modals: {
        classic: false
      },
      formData: {
        postTemplateID: "",
        title: "",
        postTemplate: "",
        contentType_ID: ""
      },
      form: "",
      elements: [],
      formName: "",
      formId: null,
      formContent: "",
      contentTypes: [],
      categories: [],
      myObject: []
    };
  },

  created() {
    this.getCategories();
  },

  mounted() {
    let postID = localStorage.getItem("postID");
    SurveyCreator.StylesManager.applyTheme("bootstrap");

    let options = {};
    let elements = [];

    let surveyCreator = new SurveyCreator.SurveyCreator(
      "surveyCreatorContainer",
      options
    );

    SurveyKo.Serializer.addProperty("question", {
      name: "questionID",
      type: "text"
    });

    surveyCreator.showToolbox = "right";
    surveyCreator.showPropertyGrid = "right";
    surveyCreator.rightContainerActiveItem("toolbox");

    surveyCreator.haveCommercialLicense = true;
    const vm = this;

    PageResource.get(postID)
      .then(response => {
        vm.form = response.data.postTemplate;
        vm.formData.postTemplateID = vm.form.id;
        vm.formData.title = vm.form.title;
        vm.formData.contentType_ID =  vm.form.categoryID

        elements = response.data.elements;
        let newPage = null;
        let data = elements;
        let questionArray = [];

        let pagesQuesstion = null;

        let pagesQuesstionTwo = {};
        let pagesQuesstionThree = {};
        let pagesQuesstionFour = {};
        let pagesQuesstionFive = {};
        let pagesQuesstionSix = {};
        let pagesQuesstionSept = {};
        let pagesQuesstionEight = {};
        let pagesQuesstionNine = {};
        let pagesQuesstionTen = {};

        let pagesQuestionArr = null;

        let modelObject = {};

        for (let index = 0; index < data.length; index++) {
          // newPage = index + 1;

          let createPage = data[index].field;
          let questionID = data[index];

          let modelpagesQuesstion = {};
          let i = 0;

          let counter = 0;

          if (index >= 1) {
            modelpagesQuesstion.choices = createPage.choices;
            modelpagesQuesstion.type = createPage.type;
            modelpagesQuesstion.questionID = questionID.id.toString();
            modelpagesQuesstion.name = createPage.name;
            modelpagesQuesstion.otherText = createPage.otherText;
            modelpagesQuesstion.title = createPage.title;

            if (index === 1) {
              pagesQuesstionTwo = modelpagesQuesstion;
            } else if (index == 2) {
              pagesQuesstionThree = modelpagesQuesstion;
            } else if (index === 3) {
              pagesQuesstionFour = modelpagesQuesstion;
            } else if (index === 4) {
              pagesQuesstionFive = modelpagesQuesstion;
            } else if (index === 5) {
              pagesQuesstionSix = modelpagesQuesstion;
            } else if (index === 6) {
              pagesQuesstionSept = modelpagesQuesstion;
            } else if (counter === 7) {
              pagesQuesstionEight = modelpagesQuesstion;
            } else if (index === 8) {
              pagesQuesstionNine = modelpagesQuesstion;
            } else if (index === 9) {
              pagesQuesstionTen = modelpagesQuesstion;
            }

            questionArray[0] = pagesQuesstionTwo;
            questionArray[1] = pagesQuesstionThree;
            questionArray[2] = pagesQuesstionFour;
            questionArray[3] = pagesQuesstionFive;
            questionArray[4] = pagesQuesstionSix;
            questionArray[5] = pagesQuesstionSept;
            questionArray[6] = pagesQuesstionEight;
            questionArray[7] = pagesQuesstionNine;
            questionArray[8] = pagesQuesstionTen;
          }
        }

        surveyCreator.deleteElement(surveyCreator.survey.pages[0]);

        surveyCreator.addPage(1);
        let page =
          surveyCreator.survey.pages[surveyCreator.survey.pages.length - 1];

        page.fromJSON({
          elements: [
            {
              choices: data[0].field.choices,
              type: data[0].field.type,
              questionID: data[0].id,
              name: data[0].field.name,
              title: data[0].field.title
            },
            questionArray[0],
            questionArray[1],
            questionArray[2],
            questionArray[3],
            questionArray[4],
            questionArray[5],
            questionArray[6],
            questionArray[7]
          ]
        });
      })
      .catch(error => {});

    surveyCreator.saveSurveyFunc = function() {
      const formContent = JSON.parse(this.text);
      vm.openUpdateModal(formContent);
    };
  },

  methods: {
    showAlertMessage(message, type) {
      this.$message.closeAll();
      this.$message({
        type: type,
        message: message
      });
    },
    handleCloseModal() {
      this.modals.classic = false;
    },
    openUpdateModal(formContent) {
      this.modals.classic = true;
      this.formContent = formContent;
    },
    async getCategories() {
      await CategoryResource.list({})
        .then(response => {
          this.categories = response.data;
          this.categories.forEach((value) => {
             if(value.name.toLowerCase().includes("content type")) {
                this.contentTypes = value.children;
             }
          });
        })
        .catch(error => {
          console.log("error occured");
        });
    },
    async updateForm() {
      let obj = [];
      let content = this.formContent;

      content.pages.forEach((element, index) => {
        if (element.elements) {
          element.elements.forEach((value, key) => {
            let myValue = value.name;
            if (value.name.includes(":")) {
              let nameID = value.name.split(":");
              obj[index] = {
                id: 15,
                type: value.type,
                name: nameID[0],
                title: value.title,
                choices: !value.choices ? "" : value.choices
              };
            } else {
              obj[index] = value;
            }
          });
        }
      });

      let pages = {
        pages: [
          {
            name: "page1",
            generalFields: [],
            elements: obj
          }
        ]
      };

      let form = new FormData();
      form.append("postTemplateID", this.formData.postTemplateID);
      form.append("title", this.formData.title);
      form.append("contentType_ID", this.formData.contentType_ID);
      form.append("postTemplate", JSON.stringify(content));

      // form.forEach((value, key) => {
      //    console.log("key %s: value %s", key, value);
      // });
      // return;

      await UpdatePageResource.store(form)
        .then(response => {
          this.$router.push({ name: "PageBuilderIndex" });
          this.showAlertMessage(
            this.$t("post_template_is_updated_successfully"),
            "success"
          );
        })
        .catch(error => {
          if (error.response.data.error) {
            this.$refs.formBuilderForm.setErrors(
              error.response.data.error.message
            );
          }
        });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
